<template>
    <div id="main3">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="page">
            <empty-table-message v-if="atendimentocheckList.length == 0" />
            <b-table
                v-else
                :data="atendimentocheckList"
                class="data-table table-check"
                striped
                :mobile-cards="false"
                :paginated="false"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.label ? f.label : f.key) || '---'"
                    :width="f.width"
                    v-slot="props"
                    :centered="f.centered"
                >
                    <template v-if="f.key == 'checkin' || f.key == 'checkout'">
                        {{ props.row[f.key] | moment('HH:mm:ss') }}
                    </template>
                    <template v-else-if="f.key == 'tempo-total-lps'">
                        {{ props.row['tempoTotaLps'] }}
                    </template>
                    <template v-else-if="f.key == 'mapa'">
                        <span
                            v-if="verifyLocationIsValid(props.row.latitude, props.row.longitude)"
                            @click="showModalMaps(props.row)"
                        >
                            <b-icon
                                class="map-marker"
                                pack="fas"
                                icon="map-marker-alt"
                                size="is-medium"
                                type="is-primary"
                            />
                        </span>
                        <b-icon
                            v-else
                            pack="fas"
                            icon="map-marker-alt"
                            size="is-medium"
                            type="is-gray"
                        />
                    </template>
                    <template v-else-if="f.key == 'foto-check-in'">
                        <span 
                            v-if="props.row.urlDocumentoCheckIn" 
                            @click="showModalImage(props.row.urlDocumentoCheckIn, 'check-in')">
                            <b-icon
                                class="map-marker"
                                pack="fas"
                                icon="image"
                                size="is-medium"
                                type="is-primary"
                            />
                        </span>
                        <b-icon v-else pack="fas" icon="image" size="is-medium" type="is-gray" />
                    </template>
                    <template v-else-if="f.key == 'foto-check-out'">
                        <span 
                            v-if="props.row.urlDocumentoCheckOut" 
                            @click="showModalImage(props.row.urlDocumentoCheckOut, 'check-out')">
                            <b-icon
                                class="map-marker"
                                pack="fas"
                                icon="image"
                                size="is-medium"
                                type="is-primary"
                            />
                        </span>
                        <b-icon v-else pack="fas" icon="image" size="is-medium" type="is-gray" />
                    </template>
                    <template v-else>
                        {{ props.row[f.key] ? props.row[f.key] : '---' }}
                    </template>
                </b-table-column>
            </b-table>
        </div>
        <b-modal :active.sync="isShowModalMaps">
            <div class="bg">
                <RelatorioLPSMapsModal :local="local" @fecharModal="fecharModalMaps" />
            </div>
        </b-modal>
        <b-modal :active.sync="isShowModalImage">
            <div class="bg">
                <RelatorioLPSImageModal 
                    :img="img" 
                    :typeCheck="typeCheck"
                    @fecharModal="fecharModalImage" 
                />
            </div>
        </b-modal>
    </div>
</template>
<script>
import AtendimentocheckService from '@/services/promotor/atendimentoLps/AtendimentocheckService';
import RelatorioLPSMapsModal from '@/components/promotor/relatorio/atendimento/modal/RelatorioLPSMapsModal.vue';
import RelatorioLPSImageModal from '@/components/promotor/relatorio/atendimento/modal/RelatorioLPSImageModal.vue';
import ContainerLoader from '@/components/content/loader/ContainerLoader.vue';

export default {
    components: {
        RelatorioLPSMapsModal,
        RelatorioLPSImageModal,
        ContainerLoader,
    },
    props: {
        permissao: {
            type: Object,
            default: () => {},
        },
        lps: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            service: new AtendimentocheckService(this.$http, this.$router),
            rangeEv: [],

            atendimentocheckList: [],
            isShowModalMaps: false,
            isShowModalImage: false,
            local: {},
            img: null,
            isLoading: false,
            filters: {
                idcontrato: 0,
                idlps: this.idlps,
                dataatendimento: new Date(),
            },
            fields: [
                { key: 'datahora', width: null },
                { key: 'nomeCliente', label: 'colaborador', width: null },
                { key: 'checkin', width: null },
                { key: 'checkout', width: null },
                { key: 'tempo-total-lps', width: null },
                { key: 'mapa', width: null, centered: true },
                { key: 'foto-check-in', width: null, centered: true },
                { key: 'foto-check-out', width: null, centered: true },
            ],
            typeCheck: '',
        };
    },
    created() {
        this.carregarDados();
    },
    methods: {
        verifyLocationIsValid(lat, lng) {
            let validLatitude = lat >= -90 && lat <= 90 && lat != 0.0 ? true : false;
            let validLongitude = lng >= -180 && lng <= 180 && lng != 0.0 ? true : false;
            return validLatitude && validLongitude ? true : false;
        },
        carregarDados() {
            this.service
                .findAllByLpsData(this.lps)
                .then((res) => {
                    this.atendimentocheckList = res.content.map((check, i) => {
                        this.rangeEv.push(i);
                        return check;
                    });
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        showModalMaps(data) {
            this.isShowModalMaps = !this.isShowModalMaps;
            this.local = this.isShowModalMaps
                ? {
                    lat: data.latitude,
                    lng: data.longitude,
                    precisao: data.precisao,
                    velocidade: data.velocidade,
                    datahora: data.datahora,
                }
                : null;
        },
        fecharModalMaps() {
            this.isShowModalMaps = false;
        },
        showModalImage(url, typeCheck) {
            this.isShowModalImage = !this.isShowModalImage;
            this.img = this.isShowModalImage ? url : null;
            this.typeCheck = typeCheck;
        },
        fecharModalImage() {
            this.isShowModalImage = false;
        },
    },
};
</script>
<style lang="scss">
@media screen and (min-width: 760px) {
    .table-check {
        .table {
            .remove-space {
                padding-left: 0;
                margin-left: 0;
                padding-right: 0;
                margin-right: 0;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.map-marker:hover {
    cursor: pointer;
    opacity: 0.5;
}
#main3 {
}
</style>
